// HKDSE 2020 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2020Samples_complete_part2 = {
  geometry: [
    {
      id: 'hkdse2020_geometry_01',
      problem: "In Figure 1, $B$ and $D$ are points on $AC$ and $AE$ respectively. $BE$ and $CD$ intersect at point $F$. It is known that $AB = BE$, $BD \\parallel CE$, $\\angle CAE = 30°$ and $\\angle ADB = 42°$. Figure 1 description: A geometric figure showing triangle ACE with point B on side AC and point D on side AE. Lines BE and CD intersect at point F inside the triangle. (a) Find $\\angle BEC$. (b) Let $\\angle BDC = \\theta$. Express $\\angle CFE$ in terms of $\\theta$.",
      problemType: "geometry_angles",
      difficulty: "intermediate",
      description: "Working with angles in geometric figures",
      graphData: {
        nodes: [
          {
            id: "triangle_ace",
            name: "Triangle ACE",
            type: "concepts",
            description: "Main triangle with points B and D",
            value: "Triangle with points B on AC, D on AE",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_angles",
            name: "Given Angles",
            type: "variables",
            description: "Known angle measurements",
            value: "∠CAE = 30°, ∠ADB = 42°",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "parallel_lines",
            name: "Parallel Lines",
            type: "concepts",
            description: "BD parallel to CE",
            value: "BD ∥ CE",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "angle_bec",
            name: "Angle BEC",
            type: "variables",
            description: "Angle to be found",
            value: "∠BEC",
            importance: 9,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "triangle_ace",
            to: "given_angles",
            type: "contains",
            strength: 8
          },
          {
            from: "parallel_lines",
            to: "angle_bec",
            type: "affects",
            strength: 8
          },
          {
            from: "given_angles",
            to: "angle_bec",
            type: "constrains",
            strength: 9
          }
        ]
      }
    }
  ],
  statistics: [
    {
      id: 'hkdse2020_statistics_01',
      problem: "The following table shows the distribution of the number of subjects taken by students in a class. Table description: Number of subjects: 4, 5, 6, 7. Number of students: 8, 12, 16, 4. (a) Write down the mean, median and standard deviation of the above distribution. (b) A new student joins the class. The new student takes $5$ subjects. Find the change in the median of the distribution caused by adding this student.",
      problemType: "statistics_distribution",
      difficulty: "intermediate",
      description: "Analyzing frequency distribution and its changes",
      graphData: {
        nodes: [
          {
            id: "frequency_table",
            name: "Frequency Table",
            type: "concepts",
            description: "Distribution of subjects per student",
            value: "4 subjects: 8 students, 5: 12, 6: 16, 7: 4",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "mean_calculation",
            name: "Mean Calculation",
            type: "methods",
            description: "Calculating average number of subjects",
            value: "Mean = Σ(x × frequency) / total frequency",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "median_calculation",
            name: "Median Calculation",
            type: "methods",
            description: "Finding middle value of distribution",
            value: "Median = middle value when ordered",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "new_student_effect",
            name: "New Student Effect",
            type: "concepts",
            description: "Effect of adding student with 5 subjects",
            value: "New student: 5 subjects",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "frequency_table",
            to: "mean_calculation",
            type: "provides_data",
            strength: 9
          },
          {
            from: "frequency_table",
            to: "median_calculation",
            type: "provides_data",
            strength: 9
          },
          {
            from: "new_student_effect",
            to: "median_calculation",
            type: "affects",
            strength: 7
          }
        ]
      }
    }
  ],
  functions: [
    {
      id: 'hkdse2020_functions_01',
      problem: "The price of an $X$-brand souvenir with height $h$ cm is $\\$P$. One part of $P$ is a constant, and another part varies directly as $h^3$. When $h = 3$, $P = 59$; and when $h = 7$, $P = 691$. (a) Find the price of an $X$-brand souvenir with height $4$ cm. (b) Someone claims that the price of an $X$-brand souvenir with height $5$ cm is higher than the total price of two $X$-brand souvenirs each with height $4$ cm. Is this claim correct? Explain your answer.",
      problemType: "functions_direct_variation",
      difficulty: "intermediate",
      description: "Working with functions involving direct variation",
      graphData: {
        nodes: [
          {
            id: "function_structure",
            name: "Function Structure",
            type: "concepts",
            description: "P = constant + k(h³)",
            value: "P = c + kh³",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "direct_variation",
            name: "Direct Variation",
            type: "concepts",
            description: "Part varies directly as h³",
            value: "kh³ where k is constant",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "system_equations",
            name: "System of Equations",
            type: "methods",
            description: "Using given values to find constants",
            value: "P(3) = 59, P(7) = 691",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "price_comparison",
            name: "Price Comparison",
            type: "concepts",
            description: "Comparing prices for different heights",
            value: "P(5) vs 2×P(4)",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "function_structure",
            to: "direct_variation",
            type: "includes",
            strength: 9
          },
          {
            from: "system_equations",
            to: "function_structure",
            type: "determines",
            strength: 9
          },
          {
            from: "function_structure",
            to: "price_comparison",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics_advanced: [
    {
      id: 'hkdse2020_statistics_advanced_01',
      problem: "The following stem-and-leaf diagram shows the distribution of the weights (in grams) of letters in a bag. Stem-and-leaf table description: Stem (tens digit) represents tens place, Leaf (units digit) represents units place. Row 1: Stem 1, Leaves: 1 2 3 3. Row 2: Stem 2, Leaves: 3 3 4 5 6 9 9. Row 3: Stem 3, Leaves: 1 6 7 8 8 8. Row 4: Stem 4, Leaves: 2. Row 5: Stem 5, Leaves: 0 w. It is known that the range of the above distribution is three times the interquartile range. (a) Find $w$. (b) If a letter is randomly drawn from the bag, find the probability that the weight of the drawn letter is not less than the mode of the distribution.",
      problemType: "statistics_stem_leaf",
      difficulty: "advanced",
      description: "Analyzing stem-and-leaf diagram with missing values",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_diagram",
            name: "Stem-and-Leaf Diagram",
            type: "concepts",
            description: "Data representation with stems and leaves",
            value: "1|1233, 2|3345699, 3|167888, 4|2, 5|0w",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "range_relationship",
            name: "Range Relationship",
            type: "concepts",
            description: "Range = 3 × IQR",
            value: "Range = 3 × IQR",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "missing_value",
            name: "Missing Value",
            type: "variables",
            description: "w to be determined",
            value: "w",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "probability_calculation",
            name: "Probability Calculation",
            type: "concepts",
            description: "Probability of weight ≥ mode",
            value: "P(weight ≥ mode)",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "stem_leaf_diagram",
            to: "range_relationship",
            type: "constrains",
            strength: 9
          },
          {
            from: "range_relationship",
            to: "missing_value",
            type: "determines",
            strength: 9
          },
          {
            from: "stem_leaf_diagram",
            to: "probability_calculation",
            type: "provides_data",
            strength: 7
          }
        ]
      }
    }
  ],
  mensuration: [
    {
      id: 'hkdse2020_mensuration_01',
      problem: "A solid right circular cone has height $36$ cm and base radius $15$ cm. The cone is divided into three parts by two planes parallel to its base. The three parts have equal heights. Express the answers in terms of $\\pi$. (a) Find the volume of the middle part of the cone. (b) Find the curved surface area of the middle part of the cone.",
      problemType: "mensuration_cone",
      difficulty: "intermediate",
      description: "Working with cone volumes and surface areas",
      graphData: {
        nodes: [
          {
            id: "cone_dimensions",
            name: "Cone Dimensions",
            type: "concepts",
            description: "Height and radius of cone",
            value: "Height = 36cm, Radius = 15cm",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "equal_division",
            name: "Equal Division",
            type: "concepts",
            description: "Three equal height parts",
            value: "Each part height = 12cm",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "volume_calculation",
            name: "Volume Calculation",
            type: "methods",
            description: "Calculating volume of middle part",
            value: "V = (1/3)πr²h",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "surface_area",
            name: "Surface Area",
            type: "concepts",
            description: "Curved surface area of middle part",
            value: "A = πrs where s is slant height",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "cone_dimensions",
            to: "equal_division",
            type: "enables",
            strength: 8
          },
          {
            from: "equal_division",
            to: "volume_calculation",
            type: "provides_data",
            strength: 9
          },
          {
            from: "equal_division",
            to: "surface_area",
            type: "provides_data",
            strength: 8
          }
        ]
      }
    }
  ],
  polynomials: [
    {
      id: 'hkdse2020_polynomials_01',
      problem: "A cubic polynomial $f(x)$ is divisible by $x - 1$. When $f(x)$ is divided by $x^2 - 1$, the remainder is $kx + 8$, where $k$ is a constant. (a) Find $k$. (b) It is known that $x + 3$ is a factor of $f(x)$. When $f(x)$ is divided by $x$, the remainder is $24$. Someone claims that all roots of the equation $f(x) = 0$ are integers. Is this claim correct? Explain your answer.",
      problemType: "polynomials_remainder_factor",
      difficulty: "advanced",
      description: "Working with polynomial division and remainder theorem",
      graphData: {
        nodes: [
          {
            id: "cubic_polynomial",
            name: "Cubic Polynomial",
            type: "concepts",
            description: "Degree 3 polynomial f(x)",
            value: "f(x) = ax³ + bx² + cx + d",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "factor_theorem",
            name: "Factor Theorem",
            type: "concepts",
            description: "f(1) = 0, f(-3) = 0",
            value: "f(a) = 0 if (x-a) is factor",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "remainder_theorem",
            name: "Remainder Theorem",
            type: "concepts",
            description: "Remainder when divided by x²-1",
            value: "Remainder = kx + 8",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "integer_roots",
            name: "Integer Roots",
            type: "concepts",
            description: "Checking if all roots are integers",
            value: "Verify if all roots are integers",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "cubic_polynomial",
            to: "factor_theorem",
            type: "satisfies",
            strength: 9
          },
          {
            from: "cubic_polynomial",
            to: "remainder_theorem",
            type: "satisfies",
            strength: 9
          },
          {
            from: "factor_theorem",
            to: "integer_roots",
            type: "constrains",
            strength: 8
          }
        ]
      }
    }
  ],
  geometry_advanced: [
    {
      id: 'hkdse2020_geometry_advanced_01',
      problem: "The coordinates of points $A$ and $B$ are $(-10, 0)$ and $(30, 0)$ respectively. Circle $C$ passes through $A$ and $B$. Let the center of $C$ be denoted as $G$. It is known that the $y$-coordinate of $G$ is $-15$. (a) Find the equation of $C$. (b) Straight line $L$ passes through $B$ and $G$. Another straight line $\\ell$ is parallel to $L$. Let $P$ be a moving point on the rectangular coordinate plane such that the perpendicular distance from $P$ to $L$ equals the perpendicular distance from $P$ to $\\ell$. Let the locus of $P$ be denoted as $\\Gamma$. It is known that $\\Gamma$ passes through $A$. (i) Describe the geometric relationship between $\\Gamma$ and $L$. (ii) Find the equation of $\\Gamma$. (iii) Suppose $\\Gamma$ and $C$ intersect at another point $H$. Someone claims that $\\angle GAH < 70°$. Do you agree? Explain your answer.",
      problemType: "geometry_locus_circle",
      difficulty: "advanced",
      description: "Working with circles, loci, and geometric relationships",
      graphData: {
        nodes: [
          {
            id: "circle_equation",
            name: "Circle Equation",
            type: "concepts",
            description: "Equation of circle passing through A and B",
            value: "(x-h)² + (y-k)² = r²",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "center_coordinates",
            name: "Center Coordinates",
            type: "variables",
            description: "Center G with y-coordinate -15",
            value: "G = (h, -15)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "locus_definition",
            name: "Locus Definition",
            type: "concepts",
            description: "Locus of points equidistant from L and ℓ",
            value: "P such that d(P,L) = d(P,ℓ)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "angle_calculation",
            name: "Angle Calculation",
            type: "concepts",
            description: "Calculating angle GAH",
            value: "∠GAH",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "center_coordinates",
            to: "circle_equation",
            type: "determines",
            strength: 9
          },
          {
            from: "locus_definition",
            to: "circle_equation",
            type: "intersects_with",
            strength: 8
          },
          {
            from: "circle_equation",
            to: "angle_calculation",
            type: "enables",
            strength: 7
          }
        ]
      }
    }
  ],
  probability: [
    {
      id: 'hkdse2020_probability_01',
      problem: "A box contains $3$ blue balls, $7$ green balls and $9$ purple balls. If $4$ balls are randomly drawn from the box simultaneously, find (a) the probability of drawing $4$ balls of the same color; (b) the probability of drawing at least $2$ balls of different colors.",
      problemType: "probability_combinations",
      difficulty: "intermediate",
      description: "Calculating probabilities using combinations",
      graphData: {
        nodes: [
          {
            id: "ball_distribution",
            name: "Ball Distribution",
            type: "concepts",
            description: "Number of balls of each color",
            value: "Blue: 3, Green: 7, Purple: 9",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "same_color_probability",
            name: "Same Color Probability",
            type: "concepts",
            description: "P(4 balls same color)",
            value: "P(same color) = favorable/total",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "different_colors_probability",
            name: "Different Colors Probability",
            type: "concepts",
            description: "P(at least 2 different colors)",
            value: "P(different) = 1 - P(same)",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "combinations",
            name: "Combinations",
            type: "methods",
            description: "Using combination formula",
            value: "C(n,r) = n!/(r!(n-r)!)",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "ball_distribution",
            to: "same_color_probability",
            type: "provides_data",
            strength: 8
          },
          {
            from: "ball_distribution",
            to: "different_colors_probability",
            type: "provides_data",
            strength: 8
          },
          {
            from: "combinations",
            to: "same_color_probability",
            type: "calculates",
            strength: 7
          }
        ]
      }
    }
  ],
  sequences: [
    {
      id: 'hkdse2020_sequences_01',
      problem: "The $3$rd term and $6$th term of a geometric sequence are $144$ and $486$ respectively. (a) Find the $1$st term of the sequence. (b) Find the smallest value of $n$ such that the sum of the first $n$ terms of the sequence is greater than $8 \\times 10^{18}$.",
      problemType: "sequences_geometric",
      difficulty: "intermediate",
      description: "Working with geometric sequences and sums",
      graphData: {
        nodes: [
          {
            id: "geometric_sequence",
            name: "Geometric Sequence",
            type: "concepts",
            description: "Sequence with common ratio r",
            value: "aₙ = a₁rⁿ⁻¹",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "given_terms",
            name: "Given Terms",
            type: "variables",
            description: "3rd term = 144, 6th term = 486",
            value: "a₃ = 144, a₆ = 486",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "first_term",
            name: "First Term",
            type: "variables",
            description: "a₁ to be found",
            value: "a₁",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "sum_inequality",
            name: "Sum Inequality",
            type: "concepts",
            description: "Sₙ > 8×10¹⁸",
            value: "Find smallest n where Sₙ > 8×10¹⁸",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "geometric_sequence",
            to: "given_terms",
            type: "satisfies",
            strength: 9
          },
          {
            from: "given_terms",
            to: "first_term",
            type: "determines",
            strength: 9
          },
          {
            from: "geometric_sequence",
            to: "sum_inequality",
            type: "enables",
            strength: 8
          }
        ]
      }
    }
  ]
}; 